function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable no-empty-function */
import React from "react";
import { PropTypes } from "prop-types";
//Material imports
import withStyles from "@mui/styles/withStyles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
// Limitless imports
import { useAppConfig, useTranslation } from "@limitless/common/hooks";
import { useExpertProfileContext } from "@limitless/expert";
import ExpertConversation from "../../expert-conversation/ExpertConversation";
const ConversationDialog = ({
  classes,
  headerText,
  message,
  onCancelClick,
  buttonColor,
  buttonVariant
}) => {
  message.inbox = {
    type: "respond"
  };
  const {
    t
  } = useTranslation();
  const {
    countryList
  } = useAppConfig();
  const {
    profile
  } = useExpertProfileContext();
  const buttonProps = {
    variant: buttonVariant || "",
    color: buttonColor || "primary"
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    scroll: "paper",
    "aria-labelledby": "responsive-dialog-title",
    classes: {
      paperWidthSm: classes.paper
    },
    disablePortal: false
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "responsive-dialog-title"
  }, t(headerText)), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(ExpertConversation, {
    profile: profile,
    message: message,
    countryList: countryList,
    handleSuggestedAnswerSelection: () => null,
    suggestedAnswerState: "",
    isParentLoading: false
  }))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, _extends({
    onClick: onCancelClick,
    autoFocus: true
  }, buttonProps), t("Close"))));
};
const styles = theme => ({
  paper: {
    width: 600,
    padding: 20,
    background: theme.palette.background.default
  }
});
export default withStyles(styles)(ConversationDialog);
ConversationDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  headerText: PropTypes.string.isRequired,
  message: PropTypes.object.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  buttonColor: PropTypes.string,
  buttonVariant: PropTypes.string
};